import FocusTrap from 'focus-trap-react';
import { observer } from 'mobx-react';
import * as React from 'react';
import { handleEnterKeyPress, handleEscKeyDown } from '../../../../../Accessibility/KeyboardEvents';
import clickOutsideStore from '../../../../../ClickOutsideStore';
import { TranslationsState, translation } from '../../../../../Translations';
import WaffleIcon from '../../../../Cutesies/WaffleIcon';
import ExpandedContent from './ExpandedContent';

type State = {
  isOpen: boolean;
};

const generateId = (min: number, max: number) => {
  const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
  return `#dropdown-container-platform_${randomNumber}`;
};
interface Props {
  ariaLabelledby?: string;
  translationsState: TranslationsState;
}
class WaffleDropdown extends React.Component<Props> {
  dropdownRef: React.RefObject<HTMLDivElement | null> = React.createRef();
  uniqueId = generateId(1000, 10000);
  state: State = {
    isOpen: false,
  };

  close = () => {
    this.setState({
      isOpen: false,
    });
  };

  toggle = () => {
    const { isOpen } = this.state;
    clickOutsideStore.addListener({ ref: this.dropdownRef, callback: this.close });
    this.setState({ isOpen: !isOpen });
  };

  render() {
    console.log(this.uniqueId);
    const { isOpen } = this.state;
    const platformNavigationDropdownMenu = translation('Platform Navigation Dropdown Menu')(
      this.props.translationsState,
    );
    return (
      <FocusTrap
        active={isOpen}
        focusTrapOptions={{
          escapeDeactivates: false,
          allowOutsideClick: true,
          fallbackFocus: this.uniqueId,
        }}
      >
        <div
          onClick={this.toggle}
          ref={this.dropdownRef}
          data-test-dropdown={true}
          id={this.uniqueId}
          tabIndex={-1}
        >
          <div
            tabIndex={0}
            onKeyUp={handleEnterKeyPress(this.toggle)}
            onKeyDown={handleEscKeyDown(this.close)}
          >
            <button
              title={platformNavigationDropdownMenu}
              className="bg-transparent p-0 sm:pt-3 sm:pl-3"
              id="platformNav"
              role="button"
              aria-label={platformNavigationDropdownMenu}
              tabIndex={-1}
              aria-haspopup="listbox"
              data-intercom-target="application-switcher"
            >
              <div style={{ width: 28, marginTop: 3 }}>
                <WaffleIcon />
              </div>
            </button>
          </div>
          {this.state.isOpen && (
            <ExpandedContent ariaLabelledby={this.props.ariaLabelledby} close={this.close} />
          )}
        </div>
      </FocusTrap>
    );
  }
}

export default observer(WaffleDropdown);
